// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main {
    margin-top: 100px;
}

.container {
    max-width: 1000px;
}

.video-container {
    height: 500px;
    overflow-y: scroll;
}

/* .video-container :hover {
    background-color: #fff;
} */
.tab-pane
{
    padding-left: 15px;
}
.reacted
{
   
    width: auto!important;
   
    height: 17px!important;
}
.nav-pills .nav-link
{
    color: #000 !important
}
.nav-pills .nav-link.active
{
    color: #6655ee !important;
    background-color: transparenT!important;

}
.history-row img{
    width: 100%;
    object-fit: cover;
    height: 86px;
}
/* .history-row {
    
    padding: 15px 0;
    margin: 5px 0px;
    cursor: pointer;
    box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.1);
    
} */
.width-100{
   
    width: 100%;
    padding: 0px 15px;
    padding: 15px 0;
    margin: 5px 0px;
    cursor: pointer;
    box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.1);
    /* margin-bottom: 15px; */
    /* margin-left: 2px; */
}
.width-100:hover{
    background: #fff;
    box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.5);
    
    
}

.video-img img {
    width: inherit;
    border-radius: 4px;
    cursor: pointer;
}

.video-details h5 {
    font-size: 15px;
}

.video-details p {
    font-size: 12px;
    margin-bottom: 7px;
}

.video-details span {
    font-size: 12px;
    color: #636161;
    border:  1px solid #636161;
    border-radius: 4px;
    padding: 4px;
    margin-right: 15px;

}

.video-desc {
    text-align: justify;
}

.icon :hover{
    /* fill: #6655ee; */
}

.icon > svg {
    width: 11%;
    margin-right: 5px;
}

a.active > svg {
    fill: #6655ee
}

a.nav-link :hover {
    color: #6655ee;
}
@media(max-width: 991px)
{
    .nav-pills .nav-link
    {
        margin-bottom: 10px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/afterLogin/public-user-activitiy/public-user-activitiy.component.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;;GAEG;AACH;;IAEI,kBAAkB;AACtB;AACA;;;IAGI,qBAAqB;;IAErB,sBAAsB;AAC1B;AACA;;IAEI;AACJ;AACA;;IAEI,yBAAyB;IACzB,uCAAuC;;AAE3C;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,YAAY;AAChB;AACA;;;;;;;GAOG;AACH;;IAEI,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,eAAe;IACf,2CAA2C;IAC3C,yBAAyB;IACzB,sBAAsB;AAC1B;AACA;IACI,gBAAgB;IAChB,2CAA2C;;;AAG/C;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,0BAA0B;IAC1B,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;;AAEtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;AAClB;AACA;;IAEI;;QAEI,mBAAmB;IACvB;AACJ","sourcesContent":[".main {\r\n    margin-top: 100px;\r\n}\r\n\r\n.container {\r\n    max-width: 1000px;\r\n}\r\n\r\n.video-container {\r\n    height: 500px;\r\n    overflow-y: scroll;\r\n}\r\n\r\n/* .video-container :hover {\r\n    background-color: #fff;\r\n} */\r\n.tab-pane\r\n{\r\n    padding-left: 15px;\r\n}\r\n.reacted\r\n{\r\n   \r\n    width: auto!important;\r\n   \r\n    height: 17px!important;\r\n}\r\n.nav-pills .nav-link\r\n{\r\n    color: #000 !important\r\n}\r\n.nav-pills .nav-link.active\r\n{\r\n    color: #6655ee !important;\r\n    background-color: transparenT!important;\r\n\r\n}\r\n.history-row img{\r\n    width: 100%;\r\n    object-fit: cover;\r\n    height: 86px;\r\n}\r\n/* .history-row {\r\n    \r\n    padding: 15px 0;\r\n    margin: 5px 0px;\r\n    cursor: pointer;\r\n    box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.1);\r\n    \r\n} */\r\n.width-100{\r\n   \r\n    width: 100%;\r\n    padding: 0px 15px;\r\n    padding: 15px 0;\r\n    margin: 5px 0px;\r\n    cursor: pointer;\r\n    box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.1);\r\n    /* margin-bottom: 15px; */\r\n    /* margin-left: 2px; */\r\n}\r\n.width-100:hover{\r\n    background: #fff;\r\n    box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.5);\r\n    \r\n    \r\n}\r\n\r\n.video-img img {\r\n    width: inherit;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n}\r\n\r\n.video-details h5 {\r\n    font-size: 15px;\r\n}\r\n\r\n.video-details p {\r\n    font-size: 12px;\r\n    margin-bottom: 7px;\r\n}\r\n\r\n.video-details span {\r\n    font-size: 12px;\r\n    color: #636161;\r\n    border:  1px solid #636161;\r\n    border-radius: 4px;\r\n    padding: 4px;\r\n    margin-right: 15px;\r\n\r\n}\r\n\r\n.video-desc {\r\n    text-align: justify;\r\n}\r\n\r\n.icon :hover{\r\n    /* fill: #6655ee; */\r\n}\r\n\r\n.icon > svg {\r\n    width: 11%;\r\n    margin-right: 5px;\r\n}\r\n\r\na.active > svg {\r\n    fill: #6655ee\r\n}\r\n\r\na.nav-link :hover {\r\n    color: #6655ee;\r\n}\r\n@media(max-width: 991px)\r\n{\r\n    .nav-pills .nav-link\r\n    {\r\n        margin-bottom: 10px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
